import { ExtFile, ServerResponse } from "../types";
import { JSON_PARSE_ERROR_RESPONSE } from "./errors.upload";

export const makeServerResponse = (success: any, message: string, payload: any): ServerResponse => {
    const result: ServerResponse = { success: success, message: message, payload: payload } as ServerResponse;
    return result;
}
export const JsonParseResponse = (xhr: XMLHttpRequest): ServerResponse => {
    try {
        const jsonResponse = JSON.parse(xhr.response);

        const success: boolean = (xhr.status >= 200 && xhr.status < 300) ? true : typeof jsonResponse.success === "boolean" ? jsonResponse.success : false;
        const message: string = typeof jsonResponse.message === "string" ? jsonResponse.message :
            success ?
                "Upload compete!. No message from server found."
                : "Error on upload. No message from server found."
            ;
        const payload: Object = jsonResponse.payload || jsonResponse || {};

        const fuiResponse: ServerResponse = {
            success: success,
            message: message,
            payload: payload
        }
        return fuiResponse
    } catch (error) {
        //console.log("FuiUpload ERROR", error);
        return JSON_PARSE_ERROR_RESPONSE;
    }
}



export const makeSuccessUploadResponse = (
    extFile: ExtFile,
    responseFui: ServerResponse
): ExtFile => {
    return {
        ...extFile,
        serverResponse: responseFui,
        uploadMessage: responseFui.message,
        uploadStatus: "success"

    }
}


export const makeErrorUploadResponse = (
    extFile: ExtFile,
    responseFui: ServerResponse
): ExtFile => {
    //console.log("makeErrorUploadResponse", extFile, responseFui);
    return {
        ...extFile,
        uploadMessage: responseFui.message,
        uploadStatus: "error",
        serverResponse: responseFui,
    }
}

